import { c as _c } from "react/compiler-runtime";
import { ProductsGrid } from "@/sanity/sanity.types";
import GridRow from "@/components/common/grid-row/grid-row";
import GridColumn from "@/components/common/grid-column/grid-column";
import SuperTitle from "@/components/common/supertitle/supertitle";
import Card from "@/components/common/card/card";
import imageUrl from "@/sanity/utilities/imageUrl";
import Image from "@/components/common/image/image";
interface IHomeReviewsProps {
  data: ProductsGrid;
}
const HowItWorks = t0 => {
  const $ = _c(18);
  const {
    data
  } = t0;
  const {
    eyebrow,
    heading,
    items,
    subheading,
    highlightCard
  } = data;
  let t1;
  if ($[0] !== eyebrow) {
    t1 = <SuperTitle>{eyebrow}</SuperTitle>;
    $[0] = eyebrow;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== heading) {
    t2 = heading && <h2 className="mt-4 max-w-[600px] text-left font-lora text-[32px] font-semibold leading-[38px] tracking-[-1px] text-[#0A2540] md:text-[46px] md:leading-[50px] lg:text-center">{heading}</h2>;
    $[2] = heading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subheading) {
    t3 = subheading && <p className="mt-6 max-w-[820px] text-left text-[16px] leading-[28px] text-[#4A4A4A] md:text-[19px] md:leading-[29px] lg:text-center">{subheading}</p>;
    $[4] = subheading;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <GridColumn><div className="mx-auto flex flex-col lg:items-center">{t1}{t2}{t3}</div></GridColumn>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== items) {
    t5 = items?.map(_temp);
    $[10] = items;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== highlightCard) {
    t6 = highlightCard && <GridColumn className="mt-2 md:mt-8"><div className="rounded-md bg-[#005472] p-6 md:p-12"><div className="flex flex-col gap-6 md:flex-row md:items-center md:gap-10"><div className="md:w-[240px] md:shrink-0"><div className="font-lora text-[84px] font-black leading-none tracking-[-2px] text-[#3BD4AE]">{highlightCard.percentage}</div><div className="mt-3 text-[13px] font-bold uppercase leading-[21px] tracking-[1px] text-white md:max-w-52">{highlightCard.label}</div></div><div className="flex-1 md:pt-1"><h3 className="text-[24px] font-bold leading-[27px] text-white">{highlightCard.title}</h3><p className="mt-4 text-[16px] leading-[24px] text-[#FFFFFFF2]">{highlightCard.description}</p></div></div></div><p className="text-[16px] leading-[24px] lg:text-center">{highlightCard.legal}</p></GridColumn>;
    $[12] = highlightCard;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <GridRow className="!gap-y-[11px] lg:!gap-y-12">{t4}{t5}{t6}</GridRow>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default HowItWorks;
function _temp(item, index) {
  return <GridColumn lg={3} key={index} className="flex"><div className="h-full rounded-[4px] border border-[#D9D9D9] bg-white p-4 shadow-[0px_1px_2px_rgba(0,0,0,0.05)]"><div className="flex items-center gap-2"><div className="flex h-6 w-6 items-center justify-center rounded-[4px] bg-[#E6F6F4]"><Image src={item?.icon?.asset ? imageUrl(item?.icon?.asset).height(20).url() : ""} alt={item?.title ?? "Image"} width={20} height={20} /></div><span className="text-[14px] font-extrabold uppercase leading-[18px] tracking-[2px] text-[#0A5067]">{item?.title}</span></div><div className="my-4 h-px bg-[#E5E5E5]" /><h3 className="text-[19px] font-semibold leading-[24px] text-[#373A36]">{item?.shortLabel}</h3><p className="mt-3 text-[15px] leading-[24px] text-[#5C5C5C]">{item?.summary}</p></div></GridColumn>;
}